import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'

const LoadingSuspense = props => {
  return (
    <div className="CompLoading" style={{margin: 50}}>      
      <Spin tip="Cargando contenidos ..." size="small">
        <div className="content" />
      </Spin>
    </div>
  )
}

const LoadingError = props => <div className="CompError">
  { /* ERROR: { props.error } */ }
</div>

const ComponentLoader = props => {

  const Loading = <LoadingSuspense { ...props } />
  const [ Comp, setComp ] = useState(Loading)

  useEffect(() => {

    const componentpath = props.component 
    const pluginName = componentpath.split('/')[0]
    const componentName = componentpath.replace(`${pluginName}/`, '');

    window.playmotiv
    .componentloader
    .load(`${ componentpath }`)
    .then(() => {

      const RegisteredComponent = window.playmotiv
      .comps[pluginName][componentName].default

      const comp = <RegisteredComponent { ...props } />

      setComp(comp)
      
    })
    .catch(error => {

      console.log('Error loading component ' + componentpath, error)
      const comp = <LoadingError error={ error } />

      setComp(comp)
    })
  }, [])

  return Comp
}

export default ComponentLoader

